"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselNavControlsMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
/** @class CarouselNavControlsMixin */
/** @method */
var CarouselNavControlsMixin = function CarouselNavControlsMixin(props) {
  return (0, _styledToken.default)('CarouselNavControls.gridColumnGap', function (gridColumnGap) {
    return (0, _styledComponents.css)(["display:grid;grid-auto-flow:column;grid-column-gap:", ";align-items:start;"], gridColumnGap ? gridColumnGap + "px" : (0, _spaceMixin.spaceMixin)('sm')(props));
  })(props);
};
exports.CarouselNavControlsMixin = CarouselNavControlsMixin;